export default __webpack_public_path__ + "static/media/camera.6feaee83.svg";